import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const hostname = window.location.hostname;

const isLocalhost   = hostname === "localhost" || hostname === "127.0.0.1";
const isReplitDev   = hostname.endsWith(".replit.dev");   // dev preview — never Sentry
const isReplitApp   = hostname.endsWith(".replit.app");   // published deployment — staging
const isFinproject  = hostname === "finproject.io" || hostname.endsWith(".finproject.io");

// Determine Sentry environment tag
const sentryEnv = isFinproject ? "production" : isReplitApp ? "staging" : "development";

// Initialize Sentry on the real domain AND on published Replit deployments.
// Never on dev previews (*.replit.dev) or localhost.
if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.PROD && !isLocalhost && !isReplitDev) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: sentryEnv,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: isFinproject ? 0.1 : 0.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      const err = hint?.originalException;
      if (err instanceof Error) {
        if (
          err.message === "Failed to fetch" ||
          err.message === "Load failed" ||
          err.message === "Network request failed"
        ) return null;
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
